<template>
  <div class="changepassword">
    <Head title="修改密码"></Head>
    <div class="changepassword_bottom">
      <p>
        已发送验证码至{{ phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2") }}
      </p>
      <div class="code">
        <van-form>
          <van-field
            v-model="code"
            placeholder="请输入验证码"
            :rules="codeRules"
            style="border-radius: 8px 8px 0px 0px"
          >
            <template #button>
              <span
                style="
                  font-size: 15px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                "
                :class="[keyFlag ? 'tel_code' : 'fontColor']"
                @click="getCoded"
                >{{ keyFlag ? "获取验证码" : num + "秒后重新获取" }}</span
              >
            </template>
          </van-field>
          <van-field
            style="
              border-bottom: 1px solid #eeeeee;
              border-radius: 0px 0px 8px 8px;
            "
            v-model="password"
            type="password"
            placeholder="请输入密码"
            :rules="passwordRules"
          >
          </van-field>
        </van-form>
      </div>
      <div
        style="
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          margin-top: 10px;
          margin-left: 25px;
        "
      >
        密码至少6位,包含数字/字母/字符2种
      </div>
    </div>
    <div class="exit">
      <van-button class="bot" :disabled="disabled" @click="set"
        >确认修改</van-button
      >
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import Head from "../components/headTabs.vue";
export default {
  name: "changepassword",
  components: {
    Head,
  },
  data() {
    return {
      num: 59,
      keyFlag: true,
      code: "", //验证码
      password: "", //密码
      disabled: true,
      // 手机号码
      phone: "",
      passwordRules: [
        {
          required: true,
          message: "", //密码不能为空（只显示placeholder为红）
          trigger: "onBlur",
        },
        {
          min: 6,
          max: 20,
          message: "密码长度为6-20位",
        },
        {
          // 自定义校验规则
          validator: (value) => {
            return /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/.test(value);
          },
          message: "'密码必须包含数字、字母、字符中的两种'",
          trigger: "onBlur",
        },
      ],
      codeRules: [
        {
          required: true,
          message: "验证码不能为空",
          trigger: "onBlur",
        },
      ],
    };
  },
  watch: {
    password() {
      this.checkPassword();
    },
  },
  created() {
    this.phone = this.$route.query.phone;
  },
  mounted() {
    this.getCoded();
  },
  methods: {
    to() {
      window.history.go(-1);
    },
    // 获取验证码
    async getCoded() {
      if (!this.keyFlag) return;
      const res = await this.$apis.loginServe.getCode({
        phone: this.phone,
        adapter: "reset_pwd",
      });
      if (res.resultCode == "200") {
        Toast("获取成功");
        this.keyFlagChange();
      } else {
        Toast(res.resultDesc);
      }
      // if (!this.isVerify) this.verifyShow = true;
    },
    // 获取验证码时间
    keyFlagChange() {
      this.keyFlag = false;
      let timer = setInterval(() => {
        if (this.num <= 0) {
          clearInterval(timer);
          this.keyFlag = true;
          this.num = 59;
        } else {
          this.num = --this.num;
        }
      }, 1000);
    },
    //密码  验证码校验
    checkPassword() {
      const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
      if (reg.test(this.password) && this.code) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    async set() {
      const res = await this.$apis.userServe.setPwd({
        pwd: this.password,
        validateCode: this.code,
      });
      if (res.resultCode == 200) {
        Toast("修改成功");
        this.$router.push("My");
      } else {
        Toast(res.resultDesc);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.changepassword {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  background: #f5f5f5;
  .changepassword_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;
    .my {
      width: 100px;
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
      margin: 0 auto;
    }
  }
  .changepassword_bottom {
    overflow: hidden;
    p {
      margin-top: 16px;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      margin-left: 25px;
    }
    .code {
      width: 94%;
      margin: 16px auto;
      .tel_code {
        color: #4a79f1;
      }
      .fontColor {
        color: #999999;
      }
    }
  }
  .exit {
    width: 100%;
    height: 44px;
    display: flex;
    justify-content: center;
    align-content: center;
    margin-top: 22px;
    .bot {
      width: 94%;
      height: 44px;
      border-radius: 22px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
      background: #4a79f1;
    }
  }
}
</style>
